'use client';

import { createScopeFromContext } from 'bunja/react';
import { createContext, useContext } from 'react';

export interface Env {
  readonly NODE_ENV: 'development' | 'production';
  readonly NEXT_PUBLIC_COMMIT_HASH: string;
  readonly NEXT_PUBLIC_VERSION: string;
  readonly NEXT_PUBLIC_SERVER_URL: string;
}

export const EnvContext = createContext<Env>({
  NODE_ENV: 'development',
  NEXT_PUBLIC_COMMIT_HASH: '',
  NEXT_PUBLIC_VERSION: '',
  NEXT_PUBLIC_SERVER_URL: '',
});

export function useEnv() {
  const env = useContext(EnvContext);
  return env;
}

export const EnvScope = createScopeFromContext(EnvContext);
